import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import useGetClientId from "../hooks/useGetClientId";
// import Select from "react-select";
import {
  GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID,
  INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
} from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import useGetCity from "../hooks/useGetCity";
import PhoneNumber from "./common/PhoneNumber";
import SidebarIcons from "./SidebarIcons";
const InviteNewMember = () => {
  const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const [userObj, setUserObj] = useState({});
  // const [allProperty, setAllProperty] = useState(null);
  const [allRoles, setAllRoles] = useState(null);
  const [city, setCity] = useState(null);
  const clientObj = useGetClientId();
  const [isMemberInvited, setIsMemberInvited] = useState(true);
  const cityObj = useGetCity();
  const [validationFlag, setValidationFlag] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  // console.log(cityObj);
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // console.log("dataObj", dataObj);

  const navigate = useNavigate();
  useEffect(() => {
    setUserObj({ name: "Test User" });
  }, []);
  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        // const extractedPropertyData = response.data.properties?.map((item) => ({
        //   value: item.propertyId,
        //   label: item.propertyName,
        // }));
        // setAllProperty(extractedPropertyData);
        setAllRoles(response.data.roles);
        // console.log("propertname", response.data.properties);
        console.log("role", response.data.roles);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const [entries, setEntries] = useState([
    {
      id: 1,
      email: "",
      role: "",
      // propertyName: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      city: "",
      userType: "",
      status: "active",
    }, // Initial entry
  ]);

  const addEntry = () => {
    const newId =
      entries.length > 0 ? Math.max(...entries.map((e) => e.id)) + 1 : 1;
    setEntries([
      ...entries,
      {
        id: newId,
        email: "",
        role: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        userType: "",
        status: "active",
        city: "",
        // propertyName: "",
      },
    ]);
  };

  const removeEntry = (id) => {
    setEntries(entries?.filter((entry) => entry.id !== id));
  };

  const isValidEmailOrMobile = (value) => {
    // Email regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //.com or .in    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const additionalemailRegex = /^[^\s@]+@[^\s@]+\.(com|in|co\.in|co\.uk)$/;
    const valid = additionalemailRegex.test(value);
    return valid;
  };

  const handleChange = (id, field, value) => {
    if (field === "phoneNumber") {
      console.log("value", value);
      const rawNumber = value?.mobileNumber
        .replace(value?.mobileDialCode, "")
        .replace(/^\+/, "");
      const formattedNumber = `+${value?.mobileDialCode}-${rawNumber}` || "";
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: formattedNumber } : entry
        )
      );
      console.log("formattedNumber", formattedNumber);
    } else {
      setEntries(
        entries?.map((entry) =>
          entry.id === id ? { ...entry, [field]: value } : entry
        )
      );
    }
  };

  const firstNameRef = useRef({});
  const lastNameRef = useRef({});
  const emailRef = useRef({});
  const phoneRef = useRef({});
  const typeRef = useRef({});
  const cityRef = useRef({});
  const roleRef = useRef({});

  const handleSave = (event) => {
    event.preventDefault();
    console.log(entries);
    let isValid = true;
    setValidationFlag(false);
    entries.forEach((entry) => {
      const fRef = firstNameRef.current[entry.id];
      if (!(entry.firstName ?? "").trim()) {
        if (fRef) {
          fRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (fRef) {
          fRef.style.border = "1px solid #ced4da";
        }
      }

      const lRef = lastNameRef.current[entry.id];
      if (!(entry.lastName ?? "").trim()) {
        if (lRef) {
          lRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (lRef) {
          lRef.style.border = "1px solid #ced4da";
        }
      }

      const eRef = emailRef.current[entry.id];
      if (!(entry.email ?? "").trim() || !isValidEmailOrMobile(entry.email)) {
        if (eRef) {
          eRef.style.border = "1px solid red";
        }
        isValid = false;
      } else {
        if (eRef) {
          eRef.style.border = "1px solid #ced4da";
        }
      }

      // const input = phoneRef.current[entry.id];
      // if (input) {
      //   if (!entry.phoneNumber) {
      //     input.parentNode.style.border = "1px solid red";
      //   } else {
      //     input.parentNode.style.border = "1px solid #ced4da";
      //   }
      // }

      const tRef = typeRef.current[entry.id];
      if (!(entry.userType ?? "").trim()) {
        if (tRef) tRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (tRef) tRef.style.border = "1px solid #ced4da";
      }

      const cRef = cityRef.current[entry.id];
      if (!(entry.city ?? "").trim()) {
        if (cRef) cRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (cRef) cRef.style.border = "1px solid #ced4da";
      }

      const rRef = roleRef.current[entry.id];
      if (!(entry.role ?? "").trim()) {
        if (rRef) rRef.style.border = "1px solid red";
        isValid = false;
      } else {
        if (rRef) rRef.style.border = "1px solid #ced4da";
      }
    });

    if (!isValid) {
      setValidationFlag(true);
      return;
    }
    handleInviteUser();
  };

  const handleInviteUser = async () => {
    console.log(entries);
    const payload = entries?.map((item) => ({
      clientId: clientObj.clientId,
      //propertyId: item?.propertyName?.value,
      roleId: item.role,
      userEmail: item.email,
      firstName: item.firstName,
      lastName: item.lastName,
      phoneNumber: item.phoneNumber,
      userType: item.userType,
      cityId: item.city,
      userStatus: item.status,
      userId: 0,
    }));
    const finalPayload = {
      assignments: payload,
      isMemberInvited: isMemberInvited,
    };

    try {
      const response = await http.post(
        INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2,
        finalPayload
      );

      if (response.status === 200) {
        const result = response?.data.results;
        if (result && result.length > 0 && result[0]?.status !== "Error") {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Members are successfully invited",
          });
          setEntries([
            {
              id: 1,
              email: "",
              role: "",
              propertyName: "",
              firstName: "",
              lastName: "",
              phoneNumber: "",
              userType: "",
              status: "active",
              city: "",
            }, // Initial entry
          ]);
        } else {
          const message = result[0]?.message || "Failed to invite members";
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: message,
          });
        }
      }

      if (!response.status) {
        setIsMemberInvited(false);
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      if (error.status === 400) {
        setIsMemberInvited(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: error?.data?.title,
        });
      }
    }
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          {/* <Sidebar
            isCollapsed={hideSidebar}
            onToggle={() => setHideSidebar((v) => !v)}
          /> */}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="dashboard_header">
              <h2 className="mb-0">Invite New Member</h2>
              <div className="d-flex flex-row justify-content-between">
                <p className="header-description">Invite a new member</p>
              </div>
            </div>

            <div >
              {entries?.map((entry, index) => (
                // eslint-disable-next-line react/jsx-key,
                <>
                  <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
                    <div
                      className="card-body-section"
                    >
                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          First Name <span className="label-star">*</span>
                        </label>
                        <input
                          type="text"
                          maxLength="50"
                          // className="form-control"
                          id="firstname"
                          required
                          placeholder="First Name"
                          value={entry.firstName}
                          ref={(el) => (firstNameRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "firstName", e.target.value)
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Last Name <span className="label-star">*</span>
                        </label>
                        <input
                          type="lastname"
                          maxLength="50"
                          // className="form-control"
                          id="floatingInput"
                          placeholder="Last Name"
                          required
                          value={entry.lastName}
                          ref={(el) => (lastNameRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "lastName", e.target.value)
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Email <span className="label-star">*</span>
                        </label>
                        <input
                          type="email"
                          // className="form-control"
                          id="floatingInput"
                          placeholder="Enter email address"
                          value={entry.email}
                          ref={(el) => (emailRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "email", e.target.value)
                          }
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="firstname"
                          // className="form-label text-start d-block fw-semibold"
                        >
                          Mobile Number{" "}
                        </label>
                        <PhoneNumber
                          setPhoneNumber={(e) => {
                            handleChange(entry.id, "phoneNumber", e);
                          }}
                          phoneNumber={{
                            mobileNumber: entry.phoneNumber,
                            mobileCountryCode: "",
                            mobileDialCode: "",
                          }}
                          inputRef={(el) => (phoneRef.current[entry.id] = el)}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={`userType-${entry.id}`}>
                          Type <span className="label-star">*</span>
                        </label>
                        <select
                          name="role"
                          id={`userType-${entry.id}`}
                          aria-label="Floating label select example"
                          value={entry.userType} // <-- binds to state
                          ref={(el) => (typeRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "userType", e.target.value)
                          }
                        >
                          <option value="">Select Type</option>
                          <option value="Internal Staff">Internal Staff</option>
                          <option value="Contractor">Contractor</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={`city-${entry.id}`}>
                          City <span className="label-star">*</span>
                        </label>
                        <select
                          name="city"
                          id={`city-${entry.id}`}
                          aria-label="Floating label select example"
                          value={entry.city}
                          ref={(el) => (cityRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "city", e.target.value)
                          }
                        >
                          <option value="">Select City</option>
                          {city?.map((data) => (
                            <option key={data?.cityId} value={data?.cityId}>
                              {data.cityName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor={`role-${entry.id}`}>
                          Role <span className="label-star">*</span>
                        </label>
                        <select
                          name="role"
                          id={`role-${entry.id}`}
                          aria-label="Floating label select example"
                          value={entry.role}
                          ref={(el) => (roleRef.current[entry.id] = el)}
                          onChange={(e) =>
                            handleChange(entry.id, "role", e.target.value)
                          }
                        >
                          <option value="">Select a Role</option>
                          {allRoles?.map((data) => (
                            <option key={data?.roleId} value={data?.roleId}>
                              {data.roleName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="floatingSelect">
                          Status <span className="label-star">*</span>
                        </label>
                        <select
                          name="role"
                          id="floatingSelect"
                          aria-label="Floating label select example"
                          value={entry.status}
                          onChange={(e) =>
                            handleChange(entry.id, "status", e.target.value)
                          }
                        >
                          <option value="active">Active</option>
                          <option value="archived">Archived</option>
                        </select>
                      </div>
                    </div>
                    <div
                    className="col-sm-12 col-auto gap-3"
                    style={{ textAlign: "end" }}
                  >
                    <button
                      type="button"
                      className={`btn btn-light rounded ${
                        !(entries.length - 1 === index) ? "displayNone" : ""
                      }`}
                      style={{
                        fontSize: "12px",
                        background: "white",
                        color: "#212121",
                      }}
                      onClick={addEntry}
                      disabled={
                        entries.length === 0
                          ? false
                          : !(entries.length - 1 === index)
                      }
                    >
                      <i className="fa-solid fa-plus icon_rounded"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-light rounded"
                      style={{
                        fontSize: "12px",
                        background: "white",
                        color: "#212121",
                      }}
                      onClick={() => removeEntry(entry.id)}
                      disabled={entries.length === 1 ? true : false}
                    >
                      <i className="fa-solid fa-minus icon_rounded"></i>
                    </button>
                  </div>
                  </div>
                  
                </>
              ))}
            </div>
            <div className="button-container">
              
              <button
                  type="submit"
                  className="btn-primary col-sm-5 col-md-2"
                  onClick={handleSave}
                >
                  Save Member
                </button>
              
                <button
                  type="button"
                  className="btn-secondary col-sm-5 col-md-2"
                  onClick={() => {
                    navigate(
                      generatePath("/client/:clientNameParam/members", {
                        clientNameParam,
                      })
                    );
                  }}
                >
                  Cancel
                </button>
                <div>
                {" "}
                {validationFlag && (
                  <small style={{ color: "red" }} className=" mb-1">
                    * Please fill all required fields with valid details
                  </small>
                )}
              </div>
                
             
            </div>

            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={() => {
                closeButton();
              }}
            />
          </div>
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default InviteNewMember;
